import axios, { AxiosResponse } from "axios";
import i18n from "../../i18n";
import apiClient from "./apiClient";
import Cookies from "js-cookie";

// Тип ответа аутентификации
interface AuthResponse {
  id: number;
  email: string;
  roles: string[];
  access_token: string;
  refresh_token: string;
  token_type: string;
}

// Функция аутентификации
export const authenticate = async (email: string, password: string): Promise<AuthResponse> => {
  try {
    const response: AxiosResponse<AuthResponse> = await axios.post(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/auth/authenticate`,
      {
        email: email,
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при аутентификации:", error);
    throw error;
  }
};


// Функция для обновления refreshToken
export const refreshToken = async (refreshToken: string): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axios.post(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/auth/refresh-token`,
      {
        refreshToken: refreshToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
      }
    );
    console.log(response.data,12312321)
    return response.data;
  } catch (error) {
    console.error("Ошибка при обновлении токена:", error);
    throw error;
  }
};


// Функция для выхода из системы (logout)
export const logoutUser = async (refreshToken: string): Promise<void> => {
  try {
    await axios.post(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/auth/logout`,
      {
        refreshToken: refreshToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
      }
    );
    console.log("Успешный выход из системы");
  } catch (error) {
    console.error("Ошибка при выходе из системы:", error);
    throw error;
  }
};


interface UserResponse {
  firstname: string;
  lastname: string;
  email: string;
  role: string[];
}

export const getUserInfo = async (): Promise<UserResponse> => {
  try {
    // Извлекаем токен из куков
    const token = Cookies.get("access_token");

    const response: AxiosResponse<UserResponse> = await axios.get(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/user/me`,
      {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Accept": "application/json",
          "Content-Type": "application/json",
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении информации о пользователе:", error);
    throw error;
  }
};